<template lang="html">
<section class="banner-ajustick column-start" :type="navigationtype" :show="(canishow && show)">

    <a  @click="show = false" class="cerrar" >✕</a>
    <div>
      <h2 v-html="$t('popupajustick.title')"></h2>
    <p v-html="$t('popupajustick.description')"></p>
     <span @click="show = false"><router-link  :to="$t('enlaces.productos')+ '/' +$t('productos.shared.nuevo_sellante')" class="btn-dark"v-html="$t('popupajustick.boton')">
    </router-link></span>
</div>
   

    <img src="/static/img/banner-ajustick/ajustick.webp" class="ajustick" :alt="$t('alt_images.ajustick')" width="162" height="246" loading="lazy">
    
  </section>

</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
  export default  {
    name: 'banner-ajustick',
    props: [],
    mounted() {
      if(this.canishow){
      this.cambiarBanner(2);
      }
    },
    data() {
      return{     
        idbanner : 1,
        show : true
      }
    },
    methods : {
      ...mapActions(['cambiarBanner']),
    },
    computed : {
        ...mapGetters({
          navigationtype : 'getnavigationtype',
          canishow : 'getcanishow',
          lastBanner : 'getLastBanner'
        })
    }
}
</script>

<style scoped >
  .banner-ajustick {
  position: fixed;
  right: 122px;
  bottom: -450px;
  z-index: 180;
  background: white;
  padding: 20px;
  padding-left: 70px;
  max-width: 550px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  -ms-align-items: flex-start;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  transition: .8s;
}
.ajustick{
  position: absolute;
  left: -100px;
  bottom: 0;
  transition: .5s;
  transform: translateY(400px);
  transition-timing-function: ease-in-out;
  transition-delay: 1s;
}

.banner-ajustick[show=true]{
  transition-delay: 2s;
  transform: translateY(-450px);
}

.banner-ajustick[show=true] .ajustick{
  transform: translate(0);
}

h2{
  text-transform: uppercase;
  width: 100%;
  display: inline-block;
  font-size: 18px;
  line-height: 20px;
  margin-top: 10px;
  max-width: 230px;
  font-weight: bold;
}
p{
    font-size: 18px;
    width: 100%;
    max-width: 270px;
    line-height: 23px;
}

.contenedor-botones{
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 20px;
}

.contenedor-botones a{
  margin: 0 10px;
}

.cerrar{
  position: absolute;
  top: -30px;
  right: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
}

.movil{
  position: absolute;
  right: -50px;
  top: -50px;
  pointer-events: none;
  transform: translate(300px,300px);
  transition-delay: 1s;
}

[show=true] .movil{
  transition: 1s;
  transition-delay: 2.5s;
  transform: translate(0px,0px); 
}

.btn-dark{
  text-transform: uppercase;
  font-size: 13px;
  height: 40px;
  line-height: 40px;
  padding: 5px 15px;
}

@media screen and (max-width: 768px){

  .movil{
    display: none;
  }

  .banner-ajustick{
    right: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 2px -3px 20px 0px #00000047;
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    -ms-flex-direction: row;
    -o-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-align-items: flex-start;
    align-items: flex-start;
  }

  .logo-banner-ajustick{
    margin-right: 10px;
  }

  h2{
    margin-top: 0;
  }

  p{
    margin-bottom: 0;
  }

  .contenedor-botones{
    width: auto;
    position: absolute;
    right: 35px;
    top: 5px;
  }

  .contenedor-botones a{
    display: none;
    margin: 0;
  }


  [type="android"] a[type="android"]{
    display: inline-block;
  }

  [type="ios"] a[type="ios"]{
    display: inline-block;
  }

  .cerrar{
    top: 0px;
    color: #6d6e6f;
  }

  .banner-ajustick{
    padding-left: 150px;
  }

  .ajustick{
    left: 20px;
    top: 20px;
    width: 120px;
  }
  .banner-ajustick[show=true] .ajustick{
    transform: translateY(-78px);
  }

}

@media screen and (max-width: 600px){

  .banner-ajustick{
    padding-left: 20px;
  }
  .ajustick{
    top: -35px;
      left: auto;
      right: 35px;
      width: 100px;
    }
  
  p{
    font-size: 14px;
    }

}

@media screen and (max-width: 350px){
  h2{
    font-size: 14px;
    max-width: 130px;
    line-height: 16px;
  }
   

  .contenedor-botones{
    right: 35px;
    top: 0;
  }

  .btn-dark{
    font-size: 11px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-ajustick.vue